<template>
  <div>
    <nav class="hodo-nav d-flex justify-content-between align-items-center p-2">
      <div class="d-flex z-index">
        <router-link to="/" class="navbar-brand fs-27 fw-700 txt-pri">
          <img
            v-if="isShowLogo"
            src="../../../public/logo.svg"
            class="hidden md:block me-1 logo-nav ps-1 ps-lg-5 h-10"
          />
          <img
            src="../../../public/logo.png"
            class="me-1 logo-nav ps-1 ps-lg-5 h-10"
            :class="show_mini_nav ? 'hidden' : 'md:hidden'"
          />
        </router-link>
      </div>
      <div class="navbar-items d-flex items-center z-index">
        <div class="d-none d-lg-flex">
          <template v-for="(nav, index) in navigation">
            <router-link
              class="nav-link fw-500 fs-16"
              :class="isRouteNames([...nav.to.name]) ? 'active txt-pri' : 'txt-black'
            "
              v-if="nav.isProd"
              :to="nav.to.path"
              :key="`nav-${index}`"
            >{{ nav.title }}</router-link>
          </template>
        </div>

        <!-- language -->
        <transition name="fade">
          <div class="nav-item dropdown dropdown-pull-right trans-fade" v-if="!show_mini_nav">
            <a
              class="nav-link dropdown-toggle fs-16 fw-500 d-flex align-items-center"
              style="padding: 0.5rem 0 !important"
              href="#"
              id="navbarDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="me-1"
              >
                <path
                  d="M13 23C18.5228 23 23 18.5228 23 13C23 7.47715 18.5228 3 13 3C7.47715 3 3 7.47715 3 13C3 18.5228 7.47715 23 13 23Z"
                  stroke="#5D5D5D"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.99961 4H9.99961C8.04961 9.84 8.04961 16.16 9.99961 22H8.99961"
                  stroke="#5D5D5D"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16 4C17.95 9.84 17.95 16.16 16 22"
                  stroke="#5D5D5D"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M4 17V16C9.84 17.95 16.16 17.95 22 16V17"
                  stroke="#5D5D5D"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M4 9.99998C9.84 8.04998 16.16 8.04998 22 9.99998"
                  stroke="#5D5D5D"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span class="d-none d-sm-flex">{{ lang === "vi" ? "Tiếng Việt" : "English" }}</span>
              <span class="d-sm-none">{{ lang === "vi" ? "VI" : "EN" }}</span>

              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="ms-1"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.2071 9.79289C15.8166 9.40237 15.1834 9.40237 14.7929 9.79289L12 12.5858L9.20711 9.79289C8.81658 9.40237 8.18342 9.40237 7.79289 9.79289C7.40237 10.1834 7.40237 10.8166 7.79289 11.2071L11.2929 14.7071C11.6834 15.0976 12.3166 15.0976 12.7071 14.7071L16.2071 11.2071C16.5976 10.8166 16.5976 10.1834 16.2071 9.79289Z"
                  fill="#777E91"
                />
              </svg>
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li>
                <a
                  class="dropdown-item fs-16 txt-black"
                  href="javascript:;"
                  @click="changeLang('vi')"
                >Tiếng Việt</a>
              </li>
              <li>
                <a
                  class="dropdown-item fs-16 txt-black blocked"
                  href="javascript:;"
                  @click="changeLang('en')"
                >English</a>
              </li>
            </ul>
          </div>
        </transition>
        <!-- /language -->

        <!-- notification -->
        <transition name="fade">
          <div
            class="nav-item dropdown dropdown-pull-right"
            v-if="$user && !show_mini_nav"
            @click="getNotifications()"
          >
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <svg
                width="24"
                height="28"
                viewBox="0 0 24 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.0209 3.0882C8.34087 3.0882 5.36087 6.39247 5.36087 10.4729V12.8014C5.36087 13.5554 5.08087 14.6864 4.73087 15.3295L3.46087 17.6802C2.68087 19.1328 3.22087 20.7517 4.66087 21.2839C9.44087 23.0469 14.6109 23.0469 19.3909 21.2839C20.7409 20.7849 21.3209 19.033 20.5909 17.6802L19.3209 15.3295C18.9709 14.6864 18.6909 13.5444 18.6909 12.8014V10.4729C18.6809 6.41465 15.6809 3.0882 12.0209 3.0882Z"
                  stroke="#292D32"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                />
                <path
                  d="M15.3299 21.7385C15.3299 23.7677 13.8299 25.4309 11.9999 25.4309C11.0899 25.4309 10.2499 25.0095 9.64992 24.3442C9.04992 23.679 8.66992 22.7476 8.66992 21.7385"
                  stroke="#292D32"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                />
              </svg>
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li>
                <a class="dropdown-item fs-16 txt-black mb-2" href="javascript:;">Thông báo gần đây</a>
              </li>
              <li v-if="(!notifications || !notifications.length) && !loading">
                <a
                  class="dropdown-item fs-16 txt-black mb-2 pt-3 pb-5"
                  href="javascript:;"
                >Chưa có thông báo nào</a>
              </li>
              <li v-for="noti in notifications" :key="noti.id">
                <a
                  class="dropdown-item d-flex dropdown-item-noti mb-2"
                  href="javascript:;"
                  @click="onClickNoti(noti)"
                >
                  <div class="me-2">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      v-if="noti.type === 'DoctorPostTopicCommentNotify'"
                    >
                      <path
                        d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
                        fill="#476DD6"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.5406 23.4665L12 26.7L10.9727 23.7498C10.6148 22.722 9.64574 22.0333 8.55747 22.0333C7.14502 22.0333 6 20.8883 6 19.4759V10.7833C6 8.71226 7.67893 7.03333 9.75 7.03333H22.25C24.3211 7.03333 26 8.71226 26 10.7833V18.2833C26 20.3544 24.3211 22.0333 22.25 22.0333H17.4893C16.3386 22.0333 15.2515 22.5617 14.5406 23.4665ZM14.6667 14.0334C14.6667 15.5062 13.4728 16.7001 12 16.7001C10.5273 16.7001 9.33336 15.5062 9.33336 14.0334C9.33336 12.5607 10.5273 11.3668 12 11.3668C13.4728 11.3668 14.6667 12.5607 14.6667 14.0334ZM17.3333 11.2625C16.8155 11.2625 16.3958 11.6823 16.3958 12.2C16.3958 12.7178 16.8155 13.1375 17.3333 13.1375H22.3333C22.8511 13.1375 23.2708 12.7178 23.2708 12.2C23.2708 11.6823 22.8511 11.2625 22.3333 11.2625H17.3333ZM17.3333 14.7625C16.8155 14.7625 16.3958 15.1823 16.3958 15.7C16.3958 16.2178 16.8155 16.6375 17.3333 16.6375H22.3333C22.8511 16.6375 23.2708 16.2178 23.2708 15.7C23.2708 15.1823 22.8511 14.7625 22.3333 14.7625H17.3333Z"
                        fill="white"
                      />
                    </svg>
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      v-if="noti.type === 'DoctorAcceptPersonDiseasesNotify'"
                    >
                      <path
                        d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
                        fill="#F86845"
                      />
                      <circle cx="15.803" cy="11.7347" r="4.08429" fill="white" />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.16237 18.1453C7.54757 18.5809 6.97891 19.0508 6.55442 19.5256C6.1318 19.9983 6 20.641 6 21.275V22.1488C6 22.5572 6.24506 23.66 7.22529 23.9867C10.4992 25.2837 12.3311 25.5842 15.5981 25.6204C18.8651 25.5842 20.697 25.2837 23.9709 23.9867C24.9511 23.66 25.1962 22.5572 25.1962 22.1488V21.275C25.1962 20.641 25.0644 19.9983 24.6418 19.5256C24.0976 18.917 23.3166 18.3164 22.5052 17.7858C22.4133 18.719 21.9947 19.4709 21.6321 19.9186C21.8059 20.0858 21.9428 20.2967 22.0236 20.5414C22.2889 21.3446 21.8529 22.2108 21.0497 22.4761C20.2465 22.7415 19.3803 22.3054 19.115 21.5023C18.8496 20.6991 19.2857 19.8329 20.0889 19.5675C20.4353 19.4531 20.7937 19.4693 21.11 19.5888C21.4548 19.1878 21.9094 18.398 21.9104 17.4118C21.0713 16.9037 20.2532 16.486 19.6824 16.2266L16.5406 20.3109L16.2107 18.2687L16.6192 17.6561L16.2107 16.635L15.5981 16.635H14.9854L14.577 17.6561L14.9854 18.2687L14.6556 20.3109L11.5138 16.2266C10.82 16.5419 9.76107 17.091 8.74294 17.752C8.70742 17.9386 8.79495 18.1924 9.00532 18.4839C9.16746 18.7086 9.37249 18.9133 9.54517 19.0606C10.367 18.742 11.143 19.0878 11.6804 19.6776C12.1907 20.2376 12.5276 21.0508 12.5623 21.8621C12.5838 21.8906 12.6031 21.9214 12.6198 21.9543C12.773 22.256 12.6526 22.6248 12.3509 22.7779C12.0492 22.9311 11.6805 22.8107 11.5273 22.509C11.3741 22.2073 11.4945 21.8386 11.7962 21.6854C11.839 21.6637 11.8831 21.6475 11.9278 21.6365C11.8491 21.0543 11.5893 20.4872 11.2276 20.0902C10.7707 19.5888 10.2049 19.4016 9.63761 19.6896C9.27081 19.8758 9.06085 20.4255 9.16255 21.1593C9.22981 21.6445 9.42874 22.1393 9.73855 22.5293C9.78046 22.4896 9.82873 22.4552 9.88283 22.4278C10.1845 22.2746 10.5533 22.395 10.7064 22.6967C10.8596 22.9984 10.7392 23.3671 10.4375 23.5203C10.1597 23.6614 9.82499 23.5704 9.65416 23.3195C9.02741 22.7913 8.65929 21.9908 8.55571 21.2434C8.46354 20.5784 8.57342 19.8495 9.00827 19.4024C8.84008 19.2455 8.66076 19.0534 8.50853 18.8424C8.36622 18.6453 8.22822 18.4047 8.16237 18.1453ZM20.281 20.1492C19.7991 20.3084 19.5375 20.8282 19.6967 21.3101C19.8559 21.792 20.3756 22.0536 20.8575 21.8944C21.3395 21.7352 21.6011 21.2155 21.4419 20.7336C21.368 20.5099 21.217 20.3342 21.0276 20.2253C20.8083 20.0992 20.5394 20.0639 20.281 20.1492Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div>
                    <p class="mb-0 fs-13 fw-500 txt-pri max-line-2">{{ noti.title }}</p>
                    <p
                      v-if="noti.body"
                      class="mb-0 fs-13 txt-black flex-wrap max-line-2"
                    >{{ noti.body }}</p>
                    <p
                      v-if="noti.body"
                      class="mb-0 fs-10 txt-gray-blur flex-wrap max-line-1 text-end"
                    >
                      {{
                      formatDateNoti(noti.created_at) }}
                    </p>
                  </div>
                </a>
              </li>
              <li v-if="loading">
                <a
                  class="dropdown-item fs-16 txt-black mb-2 pt-3 pb-3 text-center"
                  href="javascript:;"
                >
                  <span class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </transition>
        <!-- notification -->

        <!-- login btn lg-->
        <transition name="fade">
          <div class="justify-content-start d-none d-lg-flex" v-if="!$user && !show_mini_nav">
            <button class="btn btn-pri" @click="actionLogin()">
              {{
              $user
              ? lang === "vi"
              ? "Đăng xuất"
              : "Logout"
              : lang === "vi"
              ? "Đăng nhập/Đăng ký"
              : "Sign up/Sign in"
              }}
            </button>
          </div>
        </transition>
        <!-- /login btn lg-->

        <!-- account lg-->
        <transition name="fade">
          <div class="nav-item dropdown dropdown-pull-right" v-if="$user && !show_mini_nav">
            <a
              class="nav-link dropdown-toggle p-0"
              href="#"
              id="navbarDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                v-if="!$user.avatar"
              >
                <g clip-path="url(#clip0_14074_11748)">
                  <circle cx="19.9856" cy="19.9856" r="19.9856" fill="#476DD6" />
                  <path
                    d="M19.9848 8.32715C15.1739 8.32715 11.2627 12.2589 11.2627 17.0952C11.2627 21.8391 14.9535 25.6786 19.7644 25.8447C19.9113 25.8262 20.0582 25.8262 20.1684 25.8447C20.2051 25.8447 20.2235 25.8447 20.2602 25.8447C20.2786 25.8447 20.2786 25.8447 20.2969 25.8447C24.9977 25.6786 28.6885 21.8391 28.7068 17.0952C28.7068 12.2589 24.7957 8.32715 19.9848 8.32715Z"
                    fill="white"
                  />
                  <path
                    d="M29.3146 30.7547C24.1916 27.3213 15.8367 27.3213 10.6769 30.7547C8.34493 32.3237 7.05957 34.4465 7.05957 36.717C7.05957 38.9874 8.34493 41.0917 10.6586 42.6423C13.2293 44.3774 16.6079 45.245 19.9866 45.245C23.3653 45.245 26.7439 44.3774 29.3146 42.6423C31.6283 41.0733 32.9136 38.969 32.9136 36.68C32.8953 34.4096 31.6283 32.3053 29.3146 30.7547Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_14074_11748">
                    <rect width="40" height="40" rx="19.9856" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <img :src="getImageUrl()" alt class="avatar" v-if="$user.avatar" />
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li>
                <a class="dropdown-item fs-16 txt-black" href="javascript:;" @click="goToAccount()">
                  <!-- <img src="/icons/UserProfile/Navbar/home.svg" alt class="w-6 h-6 mr-1" /> -->
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-user"
                  >
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg> Tài khoản của tôi
                </a>
              </li>
              <li>
                <a class="dropdown-item fs-16 txt-black" href="javascript:;" @click="goToLanding()">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="me-2"
                  >
                    <path
                      d="M12.62 20.8096C12.28 20.9296 11.72 20.9296 11.38 20.8096C8.48 19.8196 2 15.6896 2 8.68961C2 5.59961 4.49 3.09961 7.56 3.09961C9.38 3.09961 10.99 3.97961 12 5.33961C13.01 3.97961 14.63 3.09961 16.44 3.09961C19.51 3.09961 22 5.59961 22 8.68961C22 15.6896 15.52 19.8196 12.62 20.8096Z"
                      stroke="#292D32"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2.3457 10.6801H7.96963C8.71963 10.6801 9.55963 11.2501 9.83963 11.9501L10.9796 14.8301C11.2396 15.4801 11.6496 15.4801 11.9096 14.8301L14.1996 9.02011C14.4196 8.46011 14.8296 8.44011 15.1096 8.97011L16.1496 10.9401C16.4596 11.5301 17.2596 12.0101 17.9196 12.0101H21.4997"
                      stroke="#292D32"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Hồ Sơ Sức Khỏe
                </a>
              </li>
              <!-- <li>
                <a class="dropdown-item fs-16 txt-black" href="javascript:;" @click="goToDiagnose()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-file">
                    <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                    <polyline points="13 2 13 9 20 9"></polyline>
                  </svg>
                  KQ xét nghiệm, chẩn đoán hình ảnh
                </a>
              </li>-->
              <li>
                <a class="dropdown-item fs-16 txt-black" href="javascript:;" @click="goToHR()">
                  <svg
                    class="me-2"
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16 14.7385H8C7.73478 14.7385 7.48043 14.8439 7.29289 15.0314C7.10536 15.219 7 15.4733 7 15.7385C7 16.0037 7.10536 16.2581 7.29289 16.4456C7.48043 16.6332 7.73478 16.7385 8 16.7385H16C16.2652 16.7385 16.5196 16.6332 16.7071 16.4456C16.8946 16.2581 17 16.0037 17 15.7385C17 15.4733 16.8946 15.219 16.7071 15.0314C16.5196 14.8439 16.2652 14.7385 16 14.7385ZM16 10.7385H10C9.73478 10.7385 9.48043 10.8439 9.29289 11.0314C9.10536 11.219 9 11.4733 9 11.7385C9 12.0037 9.10536 12.2581 9.29289 12.4456C9.48043 12.6332 9.73478 12.7385 10 12.7385H16C16.2652 12.7385 16.5196 12.6332 16.7071 12.4456C16.8946 12.2581 17 12.0037 17 11.7385C17 11.4733 16.8946 11.219 16.7071 11.0314C16.5196 10.8439 16.2652 10.7385 16 10.7385ZM20 4.73853H17V3.73853C17 3.47331 16.8946 3.21895 16.7071 3.03142C16.5196 2.84388 16.2652 2.73853 16 2.73853C15.7348 2.73853 15.4804 2.84388 15.2929 3.03142C15.1054 3.21895 15 3.47331 15 3.73853V4.73853H13V3.73853C13 3.47331 12.8946 3.21895 12.7071 3.03142C12.5196 2.84388 12.2652 2.73853 12 2.73853C11.7348 2.73853 11.4804 2.84388 11.2929 3.03142C11.1054 3.21895 11 3.47331 11 3.73853V4.73853H9V3.73853C9 3.47331 8.89464 3.21895 8.70711 3.03142C8.51957 2.84388 8.26522 2.73853 8 2.73853C7.73478 2.73853 7.48043 2.84388 7.29289 3.03142C7.10536 3.21895 7 3.47331 7 3.73853V4.73853H4C3.73478 4.73853 3.48043 4.84388 3.29289 5.03142C3.10536 5.21896 3 5.47331 3 5.73853V19.7385C3 20.5342 3.31607 21.2972 3.87868 21.8598C4.44129 22.4225 5.20435 22.7385 6 22.7385H18C18.7956 22.7385 19.5587 22.4225 20.1213 21.8598C20.6839 21.2972 21 20.5342 21 19.7385V5.73853C21 5.47331 20.8946 5.21896 20.7071 5.03142C20.5196 4.84388 20.2652 4.73853 20 4.73853V4.73853ZM19 19.7385C19 20.0037 18.8946 20.2581 18.7071 20.4456C18.5196 20.6332 18.2652 20.7385 18 20.7385H6C5.73478 20.7385 5.48043 20.6332 5.29289 20.4456C5.10536 20.2581 5 20.0037 5 19.7385V6.73853H7V7.73853C7 8.00374 7.10536 8.2581 7.29289 8.44563C7.48043 8.63317 7.73478 8.73853 8 8.73853C8.26522 8.73853 8.51957 8.63317 8.70711 8.44563C8.89464 8.2581 9 8.00374 9 7.73853V6.73853H11V7.73853C11 8.00374 11.1054 8.2581 11.2929 8.44563C11.4804 8.63317 11.7348 8.73853 12 8.73853C12.2652 8.73853 12.5196 8.63317 12.7071 8.44563C12.8946 8.2581 13 8.00374 13 7.73853V6.73853H15V7.73853C15 8.00374 15.1054 8.2581 15.2929 8.44563C15.4804 8.63317 15.7348 8.73853 16 8.73853C16.2652 8.73853 16.5196 8.63317 16.7071 8.44563C16.8946 8.2581 17 8.00374 17 7.73853V6.73853H19V19.7385Z"
                      fill="#5D5D5D"
                    />
                  </svg>
                  Sổ khám bệnh
                </a>
              </li>
              <li>
                <a class="dropdown-item fs-16 txt-black" href="javascript:;" @click="goToCircle()">
                  <svg
                    class="me-2"
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.87868 14.6213C11.0503 15.7929 12.9497 15.7929 14.1213 14.6213C15.2929 13.4497 15.2929 11.5502 14.1213 10.3786C12.9497 9.20707 11.0503 9.20707 9.87868 10.3786C8.70711 11.5502 8.70711 13.4497 9.87868 14.6213Z"
                      fill="currentColor"
                    />
                    <circle cx="3.99974" cy="12.4997" r="2.99974" fill="#5D5D5D" />
                    <path
                      d="M15 4.5C15 6.15685 13.6569 7.5 12 7.5C10.3431 7.5 9 6.15685 9 4.5C9 2.84315 10.3431 1.5 12 1.5C13.6569 1.5 15 2.84315 15 4.5Z"
                      fill="currentColor"
                    />
                    <path
                      d="M15 20.5C15 22.1569 13.6569 23.5 12 23.5C10.3431 23.5 9 22.1569 9 20.5C9 18.8431 10.3431 17.5 12 17.5C13.6569 17.5 15 18.8431 15 20.5Z"
                      fill="currentColor"
                    />
                    <circle cx="19.9997" cy="12.5002" r="2.99974" fill="currentColor" />
                  </svg>
                  Circle
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item fs-16 txt-black"
                  href="javascript:;"
                  @click="$router.push({ name: 'Orders' })"
                >
                  <i class="el-icon-shopping-cart-full text-2xl mr-1 align-middle" />
                  Đơn hàng
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item fs-16 txt-black"
                  href="javascript:;"
                  @click="$router.push({ name: 'PaymentReceipts' })"
                >
                  <i class="el-icon-bank-card text-2xl mr-1 align-middle" />
                  Thanh toán
                </a>
              </li>
              <li>
                <a class="dropdown-item fs-16 txt-black" href="javascript:;" @click="goToInfo()">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="me-2"
                  >
                    <path
                      d="M12.1605 10.87C12.0605 10.86 11.9405 10.86 11.8305 10.87C9.45055 10.79 7.56055 8.84 7.56055 6.44C7.56055 3.99 9.54055 2 12.0005 2C14.4505 2 16.4405 3.99 16.4405 6.44C16.4305 8.84 14.5405 10.79 12.1605 10.87Z"
                      stroke="#292D32"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7.1607 14.56C4.7407 16.18 4.7407 18.82 7.1607 20.43C9.9107 22.27 14.4207 22.27 17.1707 20.43C19.5907 18.81 19.5907 16.17 17.1707 14.56C14.4307 12.73 9.9207 12.73 7.1607 14.56Z"
                      stroke="#292D32"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Thông tin cá nhân
                </a>
              </li>
              <li>
                <a class="dropdown-item fs-16 txt-black" href="javascript:;" @click="actionLogin()">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="me-2"
                  >
                    <path
                      d="M9 3.93552C10.205 3.33671 11.5632 3 13 3C17.9706 3 22 7.02944 22 12C22 16.9706 17.9706 21 13 21C11.5632 21 10.205 20.6633 9 20.0645"
                      stroke="#DC3545"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11 12.75C11.4142 12.75 11.75 12.4142 11.75 12C11.75 11.5858 11.4142 11.25 11 11.25L11 12.75ZM1.46967 11.4697C1.17678 11.7626 1.17678 12.2374 1.46967 12.5303L6.24264 17.3033C6.53553 17.5962 7.01041 17.5962 7.3033 17.3033C7.59619 17.0104 7.59619 16.5355 7.3033 16.2426L3.06066 12L7.3033 7.75736C7.59619 7.46447 7.59619 6.98959 7.3033 6.6967C7.01041 6.40381 6.53553 6.40381 6.24264 6.6967L1.46967 11.4697ZM11 11.25L2 11.25L2 12.75L11 12.75L11 11.25Z"
                      fill="#DC3545"
                    />
                  </svg>
                  <span style="color: #DC3545">Đăng xuất</span>
                </a>
              </li>
            </ul>
          </div>
        </transition>
        <!-- /account lg -->

        <!-- Toggle btn -->
        <a
          href="javascript:;"
          class="ms-2 d-lg-none d-flex align-items-center"
          @click="show_mini_nav = !show_mini_nav"
        >
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="!show_mini_nav"
          >
            <path
              d="M6.66732 10.6667C5.93094 10.6667 5.33398 11.2636 5.33398 12C5.33398 12.7364 5.93094 13.3334 6.66732 13.3334H25.334C26.0704 13.3334 26.6673 12.7364 26.6673 12C26.6673 11.2636 26.0704 10.6667 25.334 10.6667H6.66732Z"
              fill="#777E91"
            />
            <path
              d="M6.66732 18.6667C5.93094 18.6667 5.33398 19.2636 5.33398 20C5.33398 20.7364 5.93094 21.3334 6.66732 21.3334H25.334C26.0704 21.3334 26.6673 20.7364 26.6673 20C26.6673 19.2636 26.0704 18.6667 25.334 18.6667H6.66732Z"
              fill="#777E91"
            />
          </svg>
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="show_mini_nav"
          >
            <rect
              x="23.0713"
              y="7.51477"
              width="2"
              height="22"
              rx="1"
              transform="rotate(45 23.0713 7.51477)"
              fill="#4F4F4F"
            />
            <rect
              x="24.4854"
              y="23.071"
              width="2"
              height="22"
              rx="1"
              transform="rotate(135 24.4854 23.071)"
              fill="#4F4F4F"
            />
          </svg>
        </a>
        <!-- Toggle btn -->
      </div>
    </nav>

    <transition name="fade">
      <nav class="mini-nav ps-3" v-if="show_mini_nav">
        <template v-for="(nav, index) in navigation">
          <router-link
            v-if="nav.isProd"
            class="nav-link fw-500 fs-20"
            :class="isRouteNames([...nav.to.name]) ? 'active txt-pri' : 'txt-black'
            "
            :to="nav.to.path"
            :key="`mini-nav-${index}`"
          >{{ nav.title }}</router-link>
        </template>

        <hr class="mr-4" />

        <a
          role="button"
          class="nav-link fw-500 fs-20 txt-black"
          aria-current="page"
          href="javascript:;"
          @click="actionLogin()"
        >
          {{
          $user
          ? lang === "vi"
          ? "Đăng xuất"
          : "Logout"
          : lang === "vi"
          ? "Đăng nhập / Đăng ký"
          : "Sign up / Sign in"
          }}
        </a>
      </nav>
    </transition>
  </div>
</template>

<script>
import appUtils from '../../utils/appUtils'
import { isDev } from '../../utils/constant'

export default {
  name: 'NavbarTop',
  data () {
    const initialNavigation = [
      {
        title: this.$t('home'),
        to: {
          name: ['Home'],
          path: '/'
        },
        isProd: true
      },
      {
        title: this.$t('hodo'),
        to: {
          name: ['HodoAppDetail'],
          path: '/app-hodo'
        },
        isProd: true
      },
      {
        title: this.$t('hodopro'),
        to: {
          name: ['HodoProDetail'],
          path: '/hodo-pro'
        },
        isProd: true
      },
      {
        title: this.$t('hodoConference'),
        to: {
          name: ['HodoConference'],
          path: '/hodo-conference'
        },
        isProd: false
      },
      // {
      //   title: this.$t('doctor'),
      //   to: {
      //     name: [],
      //     path: '#'
      //   }
      // },
      // {
      //   title: this.$t('pricing'),
      //   to: {
      //     name: ['Pricing'],
      //     path: '/pricing'
      //   },
      //   isProd: true
      // },
      {
        title: this.$t('handbook'),
        to: {
          name: ['HanbookDetail', 'HandbookKnowledge'],
          path: '/cam-nang-kien-thuc'
        },
        isProd: true
      },
      {
        title: this.$t('products'),
        to: {
          name: ['Ecommerce', 'DetailProduct'],
          path: '/ecommerce'
        },
        isProd: true // isDev
      }
      // {
      //   title: this.$t('services'),
      //   to: {
      //     name: ['ListServices', 'ServiceDetail'],
      //     path: '/dich-vu'
      //   }
      // }
    ]

    return {
      isDev,
      initialNavigation,
      navigation: initialNavigation,
      appUtils,
      lang: 'vi',
      current_route_name: '',
      show_mini_nav: false,
      notifications: [],
      page: 1,
      loading: false
    }
  },
  computed: {
    isShowLogo () {
      if (this.$route.meta.layout !== 'auth') {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    $route (to, from) {
      const self = this
      self.current_route_name = to.name
      self.show_mini_nav = false
    }
  },
  mounted () {
    const self = this
    self.current_route_name = self.$route.name
    if (appUtils.getLocalUser()) {
      self.getNotifications()
    }
    if (appUtils.getLocalLang()) {
      self.lang = appUtils.getLocalLang()
    } else {
      appUtils.setLocalLang('vi')
      self.lang = 'vi'
    }
  },
  methods: {
    async getNotifications () {
      const self = this
      self.notifications = []
      self.loading = true
      const params = { page: self.page, hide_next_appt: 1 }
      try {
        const resp = await self.$rf
          .getRequest('AuthRequest')
          .getNotifications(params)
        if (resp?.data) {
          await self.processNotis(resp.data)
        }
      } catch (error) {
        console.log(error)
      } finally {
        self.loading = false
      }
    },
    async processNotis (notis) {
      const self = this
      if (notis.data) {
        notis.data.forEach(n => {
          if (
            n.type.indexOf('App\\Notifications\\DoctorPostTopicCommentNotify') >
            -1
          ) {
            self.notifications.push({
              id: n.id,
              type: 'DoctorPostTopicCommentNotify',
              data: n.data,
              title: n.data?.title,
              body: n.data?.body,
              created_at: n.created_at
            })
          }
          if (
            n.type.indexOf(
              'App\\Notifications\\DoctorAcceptPersonDiseasesNotify'
            ) > -1
          ) {
            self.notifications.push({
              id: n.id,
              type: 'DoctorAcceptPersonDiseasesNotify',
              data: n.data,
              title: n.data?.title,
              body: n.data?.body,
              created_at: n.created_at
            })
          }
        })
      }
    },
    onClickNoti (noti) {
      if (noti && noti.type === 'DoctorPostTopicCommentNotify') {
        if (noti.data) {
          this.$router
            .push({
              path: `/hssk/${noti.data.person_diseases_id}/topic/${noti.data.topic_id}`
            })
            .catch(() => {})
          if (this.isRouteNames(['TopicDetail'])) {
            this.$router.go()
          }
        }
      }
      if (noti && noti.type === 'DoctorAcceptPersonDiseasesNotify') {
        if (noti.data) {
          this.$router
            .push({
              path: `/hssk/${noti.data.person_diseases_id}/bac-si-dong-y/${noti.data.doctor_id}`
            })
            .catch(() => {})
          if (this.isRouteNames(['DoctorAccept'])) {
            this.$router.go()
          }
        }
      }
    },
    isRouteNames (routeNames = []) {
      const self = this
      return routeNames.includes(self.current_route_name)
    },
    changeLang (code) {
      const self = this
      const l = code
      console.log(l)
      if (l && (l === 'vi' || l === 'en')) {
        appUtils.setLocalLang(l)
      } else {
        appUtils.setLocalLang('vi')
        self.lang = 'vi'
      }
      window.location.reload()
    },
    actionLogin () {
      this.show_mini_nav = false
      this.$user ? this.onLogout() : this.onLogin()
    },
    onLogin () {
      this.$router.push({ path: '/login' }).catch(() => {})
    },
    onLogout () {
      const r = confirm('Bạn có chắc chắn muốn đăng xuất?')
      if (!r) return
      appUtils.removeLocalUser()
      appUtils.removeLocalToken()
      this.$user = null
      setTimeout(() => {
        this.onLogin()
      }, 100)
    },
    getImageUrl () {
      return appUtils.getDocumentURL(this.$user.avatar)
    },
    goToLanding () {
      this.$router.push({ path: '/hssk' })
    },
    goToAccount () {
      this.$router.push({ path: '/my-account' })
    },
    goToDiagnose () {
      this.$router.push({ path: '/diagnose' })
    },
    goToPricing () {
      this.show_mini_nav = false
      this.$router.push({ path: '/pricing' }).catch(() => {})
    },
    goToHandBook () {
      this.show_mini_nav = false
      this.$router.push({ path: '/cam-nang-kien-thuc' }).catch(() => {})
    },
    gotoProducts () {
      this.show_mini_nav = false
      this.$router.push({ path: '/ecommerce' }).catch(() => {})
    },
    goToHodoApp () {
      this.show_mini_nav = false
      this.$router.push({ path: '/app-hodo' }).catch(() => {})
    },
    goToHodoPro () {
      this.show_mini_nav = false
      this.$router.push({ path: '/hodo-pro' }).catch(() => {})
    },
    goToServices () {
      this.show_mini_nav = false
      this.$router.push({ path: '/dich-vu' }).catch(() => {})
    },
    goToHome () {
      this.show_mini_nav = false
      this.$router.push({ path: '/' }).catch(() => {})
    },
    goToProfileInfo () {
      this.show_mini_nav = false
      this.$router.push({ path: '/thong-tin-ca-nhan' }).catch(() => {})
    },
    goToHssk () {
      this.show_mini_nav = false
      this.$router.push({ path: '/hssk' }).catch(() => {})
    },
    goToHealthRecords () {
      this.show_mini_nav = false
      this.$router.push({ path: '/health-records' }).catch(() => {})
    },
    repeatGetNewNotis () {
      const self = this
      setInterval(self.getNotifications, 30000)
    },
    formatDateNoti (dateTime) {
      return this.moment(dateTime).format('HH:mm . DD/MM/YY')
    },
    goToInfo () {
      this.$router.push({ path: '/thong-tin-ca-nhan' })
    },
    goToHR () {
      this.$router.push({ path: '/health-records' })
    },
    goToCircle () {
      this.$router.push({ path: '/circles' })
    }
  }
}
</script>

<style lang="css" scoped>
.w-160px {
  width: 160px;
}

.nav-item a,
.navbar select {
  color: #5d5d5d !important;
}

.nav-item a {
  padding-left: 15px !important;
  padding-right: 15px !important;
}

.nav-item a.active {
  background-color: #e7eaf5;
  color: #121212 !important;
  border-radius: 10px;
}

.logo-nav {
  padding-left: 56px;
}

.dropdown-pull-right {
  float: right !important;
  right: 0;
  left: auto;
}

.dropdown-pull-right > .dropdown-menu {
  right: 0;
  left: auto;
}

.dropdown-item {
  color: #292d32 !important;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  object-fit: cover;
}

@media only screen and (max-width: 992px) {
  .hide-less-lg {
    display: none;
  }
}

.dropdown-toggle::after {
  display: none;
}

.mini-nav {
  position: absolute;
  top: 100;
  background: #fff;
  height: calc(100vh - 60px);
  width: 100vw;
  z-index: 99;
}

.trans-fade {
  transition: all 0.1s ease;
}

.dropdown-menu {
  width: 350px !important;
}

.dropdown-menu li a {
  white-space: normal;
}

.z-index {
  z-index: 999;
}
</style>
